import { render } from "./RiderAnalytics.vue?vue&type=template&id=dcb4ff10"
import script from "./RiderAnalytics.vue?vue&type=script&lang=js"
export * from "./RiderAnalytics.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__